import * as Pikaday from 'pikaday'

document.addEventListener('DOMContentLoaded', () => {
  [...document.querySelectorAll('[data-date-picker]')]
    .map(elem => new Pikaday({ field: elem }))
})
